import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CONSENT_KEY = 'orbitronix_cookie_consent';

const CookieConsent = () => {
    const { t, i18n } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(CONSENT_KEY);
        if (!stored) {
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleChoice = (choice) => {
        localStorage.setItem(CONSENT_KEY, choice);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-consent" role="dialog" aria-label="Cookie consent">
            <div className="cookie-consent-card">
                <div className="cookie-consent-icon">
                    <i className="fas fa-cookie-bite"></i>
                </div>
                <div className="cookie-consent-content">
                    <h4 className="cookie-consent-title">{t('cookieConsent.title')}</h4>
                    <p className="cookie-consent-text">{t('cookieConsent.text')}</p>
                    <Link to={`/${i18n.language}/privacy-policy`} className="cookie-consent-link">
                        {t('cookieConsent.learnMore')}
                    </Link>
                </div>
                <div className="cookie-consent-actions">
                    <button type="button" className="cookie-btn cookie-btn-accept" onClick={() => handleChoice('accepted')}>
                        {t('cookieConsent.accept')}
                    </button>
                    <button type="button" className="cookie-btn cookie-btn-decline" onClick={() => handleChoice('declined')}>
                        {t('cookieConsent.decline')}
                    </button>
                </div>
            </div>
            <style>{`
                .cookie-consent {
                    position: fixed;
                    bottom: 20px;
                    left: 20px;
                    right: 20px;
                    z-index: 10000;
                    display: flex;
                    justify-content: center;
                    pointer-events: none;
                }
                .cookie-consent-card {
                    pointer-events: auto;
                    display: flex;
                    align-items: center;
                    gap: 18px;
                    max-width: 920px;
                    width: 100%;
                    background: #080c27;
                    border: 1px solid rgba(108, 92, 231, 0.25);
                    border-radius: 18px;
                    padding: 18px 22px;
                    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.55);
                    animation: cookieSlideUp 0.4s ease-out;
                }
                @keyframes cookieSlideUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .cookie-consent-icon {
                    flex-shrink: 0;
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(108, 92, 231, 0.12);
                    color: #6c5ce7;
                    font-size: 22px;
                }
                .cookie-consent-content {
                    flex: 1;
                    min-width: 0;
                }
                .cookie-consent-title {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 700;
                    margin-bottom: 4px;
                }
                .cookie-consent-text {
                    color: rgba(255, 255, 255, 0.6);
                    font-size: 12px;
                    line-height: 1.5;
                    margin: 0 0 6px;
                }
                .cookie-consent-link {
                    color: #6c5ce7;
                    font-size: 12px;
                    font-weight: 600;
                    text-decoration: none;
                }
                .cookie-consent-link:hover {
                    text-decoration: underline;
                }
                .cookie-consent-actions {
                    flex-shrink: 0;
                    display: flex;
                    gap: 10px;
                }
                .cookie-btn {
                    border: none;
                    padding: 8px 20px;
                    border-radius: 30px;
                    font-weight: 600;
                    font-size: 12px;
                    cursor: pointer;
                    transition: 0.25s;
                }
                .cookie-btn-accept {
                    background: #6c5ce7;
                    color: #fff;
                }
                .cookie-btn-accept:hover {
                    background: #5a4ad1;
                    transform: translateY(-2px);
                }
                .cookie-btn-decline {
                    background: rgba(255, 255, 255, 0.06);
                    color: rgba(255, 255, 255, 0.7);
                    border: 1px solid rgba(255, 255, 255, 0.12);
                }
                .cookie-btn-decline:hover {
                    background: rgba(255, 71, 87, 0.15);
                    color: #ff4757;
                    border-color: rgba(255, 71, 87, 0.3);
                }
                @media (max-width: 640px) {
                    .cookie-consent-card {
                        flex-direction: column;
                        text-align: center;
                        align-items: center;
                        gap: 12px;
                    }
                    .cookie-consent-actions {
                        width: 100%;
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default CookieConsent;
